/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:49:48
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:04:20
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { API, API_URL } from '@/config';
import { togglePendingStoreActions, handleErrorResponses } from '@/utils/decorators';

import {
  TOGGLE_OFFLINE_STATUS, FILL_BANNERS_LIST, TOGGLE_MOBILE_MENU,
  FILL_INFORMATIONS_ABOUT_COMPONENTS_VISIBILITY, FILL_PANEL_FOOTER_ICONS,
  FILL_RODO_TERMS, FILL_OCCASION_ZONE_TILES_CONTENTS, FILL_OCCASION_ZONE_FORM_SETTINGS,
} from './mutation-types';

export default {
  toggleOfflineStatus({ commit }) {
    commit(TOGGLE_OFFLINE_STATUS);
  },

  @togglePendingStoreActions()
  async getBannerList({ commit }) {
    const banners = (await API.get(`${API_URL}/settings/baners`)).data.data;
    commit(FILL_BANNERS_LIST, { banners });
  },

  showMobileMenuList({ commit, state }) {
    if (!state.mobileMenuIsVisible) commit(TOGGLE_MOBILE_MENU);
  },

  hideMobileMenuList({ commit, state }) {
    if (state.mobileMenuIsVisible) commit(TOGGLE_MOBILE_MENU);
  },

@togglePendingStoreActions()
  async getInformationAboutMainComponentsVisibility({ commit }) {
    const components = (await API.get(`${API_URL}/components`)).data.data;
    commit(FILL_INFORMATIONS_ABOUT_COMPONENTS_VISIBILITY, { components });
  },

@togglePendingStoreActions()
  async getPanelFooterIcons({ commit }) {
    const panelFooterIcons = (await API.get(`${API_URL}/footerIcons`)).data.data;
    commit(FILL_PANEL_FOOTER_ICONS, { panelFooterIcons });
  },

@togglePendingStoreActions()
  async getRodoTerms({ commit }) {
    const rodoTerms = (await API.get(`${API_URL}/terms/rodo`)).data.data;
    commit(FILL_RODO_TERMS, { rodoTerms });
  },

@togglePendingStoreActions()
@handleErrorResponses()
  async sendAcceptedTerms({ commit, state }, selectedTerms) {
    const termsToSend = state.rodoTerms
    .map(term => ({
      id: term.id,
      accepted: selectedTerms.includes(term.id),
    }));

    await API.put(`${API_URL}/terms/rodo`, { terms: termsToSend });
    commit(FILL_RODO_TERMS, { rodoTerms: [] });
  },

@togglePendingStoreActions()
  async getOccasionZoneTilesContents({ commit }) {
    const occasionZoneTilesContents = (await API.get(`${API_URL}/occasionZoneTiles`)).data.data;
    commit(FILL_OCCASION_ZONE_TILES_CONTENTS, { occasionZoneTilesContents });
  },

@togglePendingStoreActions()
  async getOccasionZoneFormSettings({ commit }) {
    const occasionZoneFormSettings = (await API.get(`${API_URL}/occasionZoneFormSettings`)).data.data;
    const groupedSettings = occasionZoneFormSettings.map((subject) => {
      let subjectsList = [];
      occasionZoneFormSettings.forEach((element) => {
        if (element.category_name === subject.category_name) {
          subjectsList.push({
            id: element.id,
            subject: element.name,
          });
        }
      });
      return {
        category: subject.category_name,
        subjects: subjectsList,
        id: subject.category_id,
      };
    });
    const uniqueGroupedSettings = {
      complainsCategories: groupedSettings.filter((value, index, self) =>
      index === self.findIndex(t => (
        t.category === value.category
      )),
    ),
    };
    commit(FILL_OCCASION_ZONE_FORM_SETTINGS, { occasionZoneFormSettings: uniqueGroupedSettings });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/App/actions.js